import Vue from 'vue'
import Router from 'vue-router'
import _import from './_import'
// import routeData from './routeMap';

// console.log('route=' + JSON.stringify(routeData));

Vue.use(Router)

// const routerMap = routeData;

const routerMap = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: _import('login')
  },
  {
    path: '/test1',
    name: 'TestA',
    component: _import('testA')
  },
  {
    path: '/home',
    redirect: '/home/alarmTrend',
    component: _import('layout/default'),
    children: [
      {
        path: 'serverMonitor',
        component: _import('intelligentMonitor/serverMonitor/serverMonitor'),
        name: 'serverMonitor',
        meta: {
          auth: true
        }
      },
      {
        path: 'serverMonitor/serverAppList',
        component: _import('intelligentMonitor/serverMonitor/serverAppList'),
        name: 'serverAppList',
        meta: {
          auth: true
        }
      },
      {
        path: 'serverMonitor/serverDetail',
        component: _import('intelligentMonitor/serverMonitor/serverDetail'),
        name: 'serverDetail',
        meta: {
          auth: true
        }
      },
      {
        path: 'serverMonitor/serverDetailPerformance',
        component: _import('intelligentMonitor/serverMonitor/serverDetailPerformance'),
        name: 'serverDetailPerformance',
        meta: {
          auth: true
        }
      },
      {
        path: 'userTrend',
        component: _import('systemDiagram/userTrend'),
        name: 'userTrend',
        meta: {
          auth: true
        }
      },
      {
        path: 'view',
        component: _import('intelligentMonitor/view/view'),
        name: 'view',
        meta: {
          auth: true
        }
      },
      {
        path: 'view/viewChartSelect',
        component: _import('intelligentMonitor/view/viewChartSelect'),
        name: 'viewChartSelect',
        meta: {
          auth: true
        }
      },
      {
        path: 'view/viewDataSelect',
        component: _import('intelligentMonitor/view/viewDataSelect'),
        name: 'viewDataSelect',
        meta: {
          auth: true
        }
      },
      {
        path: 'view/viewConfig',
        component: _import('intelligentMonitor/view/viewConfig'),
        name: 'viewConfig',
        meta: {
          auth: true
        }
      },
      {
        path: 'dashBoard',
        component: _import('intelligentMonitor/dashBoard/dashBoard'),
        name: 'dashBoard',
        meta: {
          auth: true
        }
      },
      {
        path: 'dashBoard/dashBoardAdd',
        component: _import('intelligentMonitor/dashBoard/dashBoardAddBak'),
        name: 'dashBoardAdd',
        meta: {
          auth: true
        }
      },
      {
        path: 'dashBoard/dashBoardDetail',
        component: _import('intelligentMonitor/dashBoard/dashBoardDetail'),
        name: 'dashBoardDetail',
        meta: {
          auth: true
        }
      },
      {
        path: 'dashBoard/handlerDashBoard',
        component: _import('intelligentMonitor/dashBoard/handlerDashBoard'),
        name: 'handlerDashBoard',
        meta: {
          auth: true
        }
      },
      {
        path: 'networkTopology',
        component: _import('intelligentMonitor/networkTopology'),
        name: 'networkTopology',
        meta: {
          auth: true
        }
      },
      {
        path: 'alarmTrend',
        component: _import('systemDiagram/alarmTrend'),
        name: 'alarmTrend',
        meta: {
          auth: true
        }
      },
      {
        path: 'dataDictionary',
        component: _import('cmdb/dataDictionary/dataDictionary'),
        name: 'dataDictionary',
        meta: {
          auth: true
        }
      },
      {
        path: 'dataDictionary/dataDicConfig',
        component: _import('cmdb/dataDictionary/dataDicConfig'),
        name: 'dataDicConfig',
        meta: {
          auth: true
        }
      },
      {
        path: 'dataDictionary/dataDicProperty',
        component: _import('cmdb/dataDictionary/dataDicProperty'),
        name: 'dataDicProperty',
        meta: {
          auth: true
        }
      },
      {
        path: 'alarmQuery',
        component: _import('intelligentMonitor/alarmQuery'),
        name: 'alarmQuery',
        meta: {
          auth: true
        }
      },
      {
        path: 'ITDeviceMonitor',
        component: _import('intelligentMonitor/ITDeviceMonitor'),
        name: 'ITDeviceMonitor',
        meta: {
          auth: true
        }
      },
      {
        path: 'menuManage',
        component: _import('systemSetting/menuManage'),
        name: 'menuManage',
        meta: {
          auth: true
        }
      },
      {
        path: 'releaseVersion',
        component: _import('systemSetting/releaseVersion'),
        name: 'releaseVersion',
        meta: {
          auth: true
        }
      },
      {
        path: 'countAlarm',
        component: _import('statistics/countAlarm'),
        name: 'countAlarm',
        meta: {
          auth: true
        }
      },
      {
        path: 'releaseStatistics',
        component: _import('statistics/releaseStatistics'),
        name: 'releaseStatistics',
        meta: {
          auth: true
        }
      },
      {
        path: 'logOperation',
        component: _import('systemSetting/logOperation'),
        name: 'logOperation',
        meta: {
          auth: true
        }
      },
      {
        path: 'dicManage',
        component: _import('systemSetting/dicManage'),
        name: 'dicManage',
        meta: {
          auth: true
        }
      },
      {
        path: 'agentManage',
        component: _import('systemSetting/agentManage'),
        name: 'agentManage',
        meta: {
          auth: true
        }
      },
      {
        path: 'roleManage',
        component: _import('systemSetting/roleManage/roleManage'),
        name: 'roleManage',
        meta: {
          auth: true
        }
      },
      {
        path: 'roleManage/handlerRoleManage',
        component: _import('systemSetting/roleManage/handlerRoleManage'),
        name: 'handlerRoleManage',
        meta: {
          auth: true
        }
      },
      {
        path: 'examinationReport',
        component: _import('statistics/examinationReport/examinationReport'),
        name: 'examinationReport',
        meta: {
          auth: true
        }
      },
      {
        path: 'examinationReport/reportDetail',
        component: _import('statistics/examinationReport/reportDetail'),
        name: 'reportDetail',
        meta: {
          auth: true
        }
      },
      {
        path: 'accidentEntry',
        component: _import('systemSetting/accidentEntry/accidentEntry'),
        name: 'accidentEntry',
        meta: {
          auth: true
        }
      },
      {
        path: 'accidentEntry/accidentDetail',
        component: _import('systemSetting/accidentEntry/accidentDetail'),
        name: 'accidentDetail',
        meta: {
          auth: true
        }
      },
      {
        path: 'workFlowRoleManage',
        component: _import('workFlow/workFlowRoleManage'),
        name: 'workFlowRoleManage',
        meta: {
          auth: true
        }
      },
      {
        path: 'workFlowTemplateManage',
        component: _import('workFlow/workFlowTemplateManage/workFlowTemplateManage'),
        name: 'workFlowTemplateManage',
        meta: {
          auth: true
        }
      },
      {
        path: 'workFlowTemplateManage/handlerWorkFlowTemplate',
        component: _import('workFlow/workFlowTemplateManage/handlerWorkFlowTemplate'),
        name: 'handlerWorkFlowTemplate',
        meta: {
          auth: true
        }
      },
      {
        path: 'dataConfig',
        component: _import('intelligentMonitor/dataConfig/dataConfig'),
        name: 'dataConfig',
        meta: {
          auth: true
        }
      },
      {
        path: 'dataConfig/handlerDataConfig',
        component: _import('intelligentMonitor/dataConfig/handlerDataConfig'),
        name: 'handlerDataConfig',
        meta: {
          auth: true
        }
      },
      {
        path: 'dial',
        component: _import('intelligentMonitor/dial/dial'),
        name: 'dial',
        meta: {
          auth: true
        }
      },
      {
        path: 'dial/dialDetail',
        component: _import('intelligentMonitor/dial/dialDetail'),
        name: 'dialDetail',
        meta: {
          auth: true
        }
      },
      {
        path: 'dial/handlerDial',
        component: _import('intelligentMonitor/dial/handlerDial'),
        name: 'handlerDial',
        meta: {
          auth: true
        }
      },
      {
        path: 'dial/handlerDialTermianl',
        component: _import('intelligentMonitor/dial/handlerDialTermianl'),
        name: 'handlerDialTermianl',
        meta: {
          auth: true
        }
      },
      {
        path: 'ITDevice',
        component: _import('cmdb/ITDevice'),
        name: 'ITDevice',
        meta: {
          auth: true
        }
      },
      {
        path: 'dataSearch',
        component: _import('logRetrieve/dataSearch/dataSearch'),
        name: 'dataSearch',
        meta: {
          auth: true
        }
      },
      {
        path: 'dataSearch/checkHistory',
        component: _import('logRetrieve/dataSearch/checkHistory'),
        name: 'dataSearchHistory',
        meta: {
          auth: true
        }
      },
      {
        path: 'dataSearch/checkData',
        component: _import('logRetrieve/dataSearch/checkData'),
        name: 'dataSearchCheck',
        meta: {
          auth: true
        }
      },
      {
        path: 'dataSearch/handlerSearchConfig',
        component: _import('logRetrieve/dataSearch/handlerSearchConfig'),
        name: 'handlerSearchConfig',
        meta: {
          auth: true
        }
      },
      {
        path: 'programPackageManage',
        component: _import('continuousDelivery/programPackage/packageManage'),
        name: 'programPackageManage',
        meta: {
          auth: true
        }
      },
      {
        path: 'programPackageManage/packageConfig',
        component: _import('continuousDelivery/programPackage/packageConfig'),
        name: 'packageConfig',
        meta: {
          auth: true
        }
      },
      {
        path: 'programPackageManage/createVersion',
        component: _import('continuousDelivery/programPackage/createVersion'),
        name: 'createVersion',
        meta: {
          auth: true
        }
      },
      {
        path: 'uclConfig',
        component: _import('continuousDelivery/uclConfig/uclConfig'),
        name: 'uclConfig',
        meta: {
          auth: true
        }
      },
      {
        path: 'uclConfig/uclConfiguration',
        component: _import('continuousDelivery/uclConfig/uclConfiguration'),
        name: 'uclConfiguration',
        meta: {
          auth: true
        }
      },
      {
        path: 'instanceManage',
        name: 'instanceManage',
        component: _import('continuousDelivery/instanceManage/instanceManage.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: 'instanceManage/instanceList',
        name: 'instanceList',
        component: _import('continuousDelivery/instanceManage/instanceList.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: 'siteList',
        component: _import('cmdb/siteList'),
        name: 'siteList',
        meta: {
          auth: true
        }
      },
      {
        path: 'hostList',
        component: _import('cmdb/hostList'),
        name: 'hostList',
        meta: {
          auth: true
        }
      },
      {
        path: 'clusterManager',
        component: _import('continuousDelivery/clusterManager/clusterManager'),
        name: 'clusterManager',
        meta: {
          auth: true
        }
      },
      {
        path: 'clusterManager/handlerCluster',
        component: _import('continuousDelivery/clusterManager/handlerCluster'),
        name: 'handlerCluster',
        meta: {
          auth: true
        }
      },
      {
        path: 'envauthority',
        component: _import('continuousDelivery/envauthority/envauthority'),
        name: 'envauthority',
        meta: {
          auth: true
        }
      },
      {
        path: 'envauthority/handlerEnvauthority',
        component: _import('continuousDelivery/envauthority/handlerEnvauthority'),
        name: 'handlerEnvauthority',
        meta: {
          auth: true
        }
      },
      {
        path: 'appDelivery',
        component: _import('continuousDelivery/appDelivery/appDelivery'),
        name: 'appDelivery',
        meta: {
          auth: true
        }
      },
      {
        path: 'appDelivery/addAppDelivery',
        component: _import('continuousDelivery/appDelivery/addAppDelivery'),
        name: 'addAppDelivery',
        meta: {
          auth: true
        }
      },
      {
        path: 'appDelivery/releaseOverview',
        component: _import('continuousDelivery/appDelivery/releaseOverview'),
        name: 'releaseOverview',
        meta: {
          auth: true
        }
      },
      {
        path: 'appDelivery/deliveryAbort',
        component: _import('continuousDelivery/appDelivery/deliveryAbort'),
        name: 'deliveryAbort',
        meta: {
          auth: true
        }
      },
      {
        path: 'ABNodeConfig',
        component: _import('continuousDelivery/ABNodeConfig'),
        name: 'ABNodeConfig',
        meta: {
          auth: true
        }
      },
      {
        path: 'ABUserConfig',
        component: _import('continuousDelivery/ABUserConfig'),
        name: 'ABUserConfig',
        meta: {
          auth: true
        }
      },
      {
        path: 'platform',
        component: _import('continuousDelivery/platform/platform'),
        name: 'platform',
        meta: {
          auth: true
        }
      },
      {
        path: 'platform/handlerPlatform',
        component: _import('continuousDelivery/platform/handlerPlatform'),
        name: 'handlerPlatform',
        meta: {
          auth: true
        }
      },
      {
        path: 'platform/history',
        component: _import('continuousDelivery/platform/history'),
        name: 'platformHistory',
        meta: {
          auth: true
        }
      },
      {
        path: 'hostMapping',
        component: _import('intelligentMonitor/hostMapping/hostMapping'),
        name: 'hostMapping',
        meta: {
          auth: true
        }
      },
      {
        path: 'hostMapping/hostMappingDetail',
        component: _import('intelligentMonitor/hostMapping/hostMappingDetail'),
        name: 'hostMappingDetail',
        meta: {
          auth: true
        }
      },
      {
        path: 'hostMapping/hostMappingModule',
        component: _import('intelligentMonitor/hostMapping/hostMappingModule'),
        name: 'hostMappingModule',
        meta: {
          auth: true
        }
      },
      {
        path: 'hostMapping/hostMappingModuleDetail',
        component: _import('intelligentMonitor/hostMapping/hostMappingModuleDetail'),
        name: 'hostMappingModuleDetail',
        meta: {
          auth: true
        }
      },
      {
        path: 'alarmStrategy',
        component: _import('systemSetting/alarmStrategy/alarmStrategy'),
        name: 'alarmStrategy',
        meta: {
          auth: true
        }
      },
      {
        path: 'alarmStrategy/editStrategy',
        component: _import('systemSetting/alarmStrategy/editStrategy'),
        name: 'editStrategy',
        meta: {
          auth: true
        }
      },
      {
        path: 'alarmStrategy/addStrategy',
        component: _import('systemSetting/alarmStrategy/addStrategy'),
        name: 'addStrategy',
        meta: {
          auth: true
        }
      },
      {
        path: 'resourceModel',
        component: _import('cmdb/resourceModel/resourceModel'),
        name: 'resourceModel',
        meta: {
          auth: true
        }
      },
      {
        path: 'resourceModel/resourceManage',
        component: _import('cmdb/resourceModel/resourceManage'),
        name: 'resourceManage',
        meta: {
          auth: true
        }
      },
      {
        path: 'repertory',
        component: _import('cmdb/repertory/repertory'),
        name: 'repertory',
        meta: {
          auth: true
        }
      },
      {
        path: 'repertory/repertoryInstance',
        component: _import('cmdb/repertory/repertoryInstance'),
        name: 'repertoryInstance',
        meta: {
          auth: true
        }
      },
      {
        path: 'repertory/repertoryInstance/s3Record',
        component: _import('cmdb/repertory/s3Record'),
        name: 's3Record',
        meta: {
          auth: true
        }
      },
      {
        path: 'logCountAnalysis',
        component: _import('analysis/logCountAnalysis'),
        name: 'logCountAnalysis',
        meta: {
          auth: true
        }
      },
      {
        path: 'userDistribution',
        component: _import('systemDiagram/userDistribution'),
        name: 'userDistribution',
        meta: {
          auth: true
        }
      },
      {
        path: 'systemWorkingQuality',
        component: _import('systemDiagram/systemQuality'),
        name: 'systemWorkingQuality',
        meta: {
          auth: true
        }
      },
      {
        path: 'kpiMapping',
        component: _import('systemSetting/kpiMapping'),
        name: 'kpiMapping',
        meta: {
          auth: true
        }
      },
      {
        path: 'logAnalysis',
        component: _import('logRetrieve/logAnalysis/logAnalysis'),
        name: 'logAnalysis',
        meta: {
          auth: true
        }
      },
      {
        path: 'appManager',
        component: _import('cmdb/appManager/appManager'),
        name: 'appManager',
        meta: {
          auth: true
        }
      },
      {
        path: 'appManager/groupManager',
        component: _import('cmdb/appManager/groupManager'),
        name: 'groupManager',
        meta: {
          auth: true
        }
      },
      {
        path: 'appManager/statusManager',
        component: _import('cmdb/appManager/statusManager'),
        name: 'statusManager',
        meta: {
          auth: true
        }
      },
      {
        path: 'alarmSubscribe',
        component: _import('systemSetting/alarmSubscribe/alarmSubscribe'),
        name: 'alarmSubscribe',
        meta: {
          auth: true
        }
      },
      {
        path: 'alarmSubscribe/alarmSubscribeEdit',
        component: _import('systemSetting/alarmSubscribe/alarmSubscribeEdit'),
        name: 'alarmSubscribeEdit',
        meta: {
          auth: true
        }
      },
      {
        path: 'loginLog',
        component: _import('systemSetting/loginLog'),
        name: 'loginLog',
        meta: {
          auth: true
        }
      },
      {
        path: 'securityRole',
        component: _import('systemSetting/securityRole'),
        name: 'securityRole',
        meta: {
          auth: true
        }
      },
      {
        path: 'userManage',
        component: _import('systemSetting/userManage'),
        name: 'userManage',
        meta: {
          auth: true
        }
      },
      {
        path: 'logComponentManage',
        component: _import('systemSetting/logComponentManage/logComponentManage'),
        name: 'logComponentManage',
        meta: {
          auth: true
        }
      },
      {
        path: 'zabbixMonitor',
        component: _import('intelligentMonitor/zabbixMonitor'),
        name: 'zabbixMonitor',
        meta: {
          auth: true
        }
      },
      {
        path: 'queryworkOrder',
        component: _import('workFlow/queryworkOrder/queryworkOrder'),
        name: 'queryworkOrder',
        meta: {
          auth: true
        }
      },
      {
        path: 'queryworkOrder/bootUpOrder',
        component: _import('workFlow/queryworkOrder/bootUpOrder'),
        name: 'bootUpOrder',
        meta: {
          auth: true
        }
      },
      {
        path: 'queryworkOrder/paasInitOrder',
        component: _import('workFlow/queryworkOrder/paasInitOrder'),
        name: 'paasInitOrder',
        meta: {
          auth: true
        }
      },
      {
        path: 'queryworkOrder/shutdownOrder',
        component: _import('workFlow/queryworkOrder/shutdownOrder'),
        name: 'shutdownOrder',
        meta: {
          auth: true
        }
      },
      {
        path: 'queryworkOrder/serviceOrder',
        component: _import('workFlow/queryworkOrder/serviceOrder'),
        name: 'serviceOrder',
        meta: {
          auth: true
        }
      },
      {
        path: 'queryworkOrder/commonOrder',
        component: _import('workFlow/queryworkOrder/commonOrder'),
        name: 'commonOrder',
        meta: {
          auth: true
        }
      },
      {
        path: 'queryworkOrder/dbPermissionOrder',
        component: _import('workFlow/queryworkOrder/dbPermissionOrder'),
        name: 'dbPermissionOrder',
        meta: {
          auth: true
        }
      },
      {
        path: 'queryworkOrder/closePermissionOrder',
        component: _import('workFlow/queryworkOrder/closePermissionOrder'),
        name: 'closePermissionOrder',
        meta: {
          auth: true
        }
      },
      {
        path: 'queryworkOrder/revokeOrder',
        component: _import('workFlow/queryworkOrder/revokeOrder'),
        name: 'revokeOrder',
        meta: {
          auth: true
        }
      },
      {
        path: 'statisticsworkOrder',
        component: _import('workFlow/statisticsworkOrder'),
        name: 'statisticsworkOrder',
        meta: {
          auth: true
        }
      },
      {
        path: 'cloudApplication',
        component: _import('workFlow/cloudApplication'),
        name: 'cloudApplication',
        meta: {
          auth: true
        }
      },
      {
        path: 'cloudApplication/bootUpRequest',
        component: _import('workFlow/cloudApplication/bootUpRequest'),
        name: 'bootUpRequest',
        meta: {
          auth: true
        }
      },
      {
        path: 'cloudApplication/paasInitRequest',
        component: _import('workFlow/cloudApplication/paasInitRequest'),
        name: 'paasInitRequest',
        meta: {
          auth: true
        }
      },
      {
        path: 'cloudApplication/serviceRequest',
        component: _import('workFlow/cloudApplication/serviceRequest'),
        name: 'serviceRequest',
        meta: {
          auth: true
        }
      },
      {
        path: 'cloudApplication/shutdownRequest',
        component: _import('workFlow/cloudApplication/shutdownRequest'),
        name: 'shutdownRequest',
        meta: {
          auth: true
        }
      },
      {
        path: 'cloudApplication/businessOnline',
        component: _import('workFlow/cloudApplication/businessOnline'),
        name: 'businessOnline',
        meta: {
          auth: true
        }
      },
      {
        path: 'cloudApplication/commonRequest',
        component: _import('workFlow/cloudApplication/commonRequest'),
        name: 'commonRequest',
        meta: {
          auth: true
        }
      },
      {
        path: 'cloudApplication/dbPermissionRequest',
        component: _import('workFlow/cloudApplication/dbPermissionRequest'),
        name: 'dbPermissionRequest',
        meta: {
          auth: true
        }
      },
      {
        path: 'cloudApplication/closePermissionRequest',
        component: _import('workFlow/cloudApplication/closePermissionRequest'),
        name: 'closePermissionRequest',
        meta: {
          auth: true
        }
      },
      {
        path: 'cloudApplication/revokeRequest',
        component: _import('workFlow/cloudApplication/revokeRequest'),
        name: 'revokeRequest',
        meta: {
          auth: true
        }
      },
      {
        path: 'siteNavigation',
        component: _import('intelligentMonitor/siteNavigation'),
        name: 'siteNavigation',
        meta: {
          auth: true
        }
      },
      {
        path: 'navigationSetting',
        component: _import('intelligentMonitor/navigationSetting'),
        name: 'navigationSetting',
        meta: {
          auth: true
        }
      },
      {
        path: 'orderStatistics',
        component: _import('workFlow/orderStatistics'),
        name: 'orderStatistics',
        meta: {
          auth: true
        }
      },
      {
        path: 'remoteConfig',
        component: _import('systemSetting/remoteConfig/remoteConfig'),
        name: 'remoteConfig',
        meta: {
          auth: true
        }
      },
      {
        path: 'remoteConfig/editSite',
        component: _import('systemSetting/remoteConfig/editSite'),
        name: 'editSite',
        meta: {
          auth: true
        }
      },
      {
        path: 'grayConfig',
        component: _import('continuousDelivery/grayConfig'),
        name: 'grayConfig',
        meta: {
          auth: true
        }
      },
      {
        path: 'grayConfigHis',
        component: _import('continuousDelivery/grayConfigHis'),
        name: 'grayConfigHis',
        meta: {
          auth: true
        }
      },
      {
        path: 'grayMonitor',
        component: _import('continuousDelivery/grayMonitor'),
        name: 'grayMonitor',
        meta: {
          auth: true
        }
      },
      {
        path: 'activeUser',
        component: _import('systemDiagram/activeUser'),
        name: 'activeUser',
        meta: {
          auth: true
        }
      },
      {
        path: 'ALBTargetGroupManager',
        component: _import('continuousDelivery/ALBTargetGroupManager'),
        name: 'ALBTargetGroupManager',
        meta: {
          auth: true
        }
      },
      {
        path: 'importantOperation',
        component: _import('continuousDelivery/importantOperation'),
        name: 'importantOperation',
        meta: {
          auth: true
        }
      },
      {
        path: 'customExpiration',
        component: _import('intelligentMonitor/customExpiration'),
        name: 'customExpiration',
        meta: {
          auth: true
        }
      },
      {
        path: 'autoInspectionReport',
        component: _import('systemDiagram/autoInspectionReport'),
        name: 'autoInspectionReport',
        meta: {
          auth: true
        }
      },
      {
        path: 'autoInspectionConfig',
        component: _import('intelligentMonitor/autoInspectionConfig'),
        name: 'autoInspectionConfig',
        meta: {
          auth: true
        }
      },
      {
        path: 'alarmManagement',
        component: _import('statistics/alarmManagement'),
        name: 'alarmManagement',
        meta: {
          auth: true
        }
      },
      {
        path: 'dutyManagement',
        component: _import('statistics/dutyManagement'),
        name: 'dutyManagement',
        meta: {
          auth: true
        }
      },
    ]
  }
]

export default new Router({
  mode: 'history',
  routes: routerMap
})
